import { RefObject, createContext } from 'react'

export type OverlayContextValue = {
  ref?: RefObject<HTMLDivElement>
}

export const OverlayContext = createContext<OverlayContextValue>({})
